import React from 'react';

const NoMatch = () => (
  <div>
    <h3>We couldn't find the page you're looking for.</h3>
  </div>
);

NoMatch.displayName = 'NoMatch';

export default NoMatch;
